import {ClipboardService} from "../../services/clipboard/ClipboardService";

const initialState = {
    day: null,
    plan: null,
};

const state = Object.assign({}, initialState);

const getters = {
};

const actions = {
    syncStateWithStore({commit}) {
        const dayKey = ClipboardService.createKey('day');
        let localStorageDay = localStorage.getItem(dayKey);
        if (localStorageDay === null) {
            commit('setDay', null);
        } else {
            commit('setDay', JSON.parse(localStorageDay));
        }

        const planKey = ClipboardService.createKey('plan');
        let localStoragePlan = localStorage.getItem(planKey);
        if (localStoragePlan === null) {
            commit('setPlan', null);
        } else {
            commit('setPlan', JSON.parse(localStoragePlan));
        }
    },
};

const mutations = {
    setDay: (state, day) => (state.day = day),
    setPlan: (state, plan) => (state.plan = plan),
};

export default {
    state,
    getters,
    actions,
    mutations
};